import { describe } from '@amzn/stencil-react-desc';
import { styledWithTheme } from "../../context";
import { px } from "../../utils";
var TheadWithoutDocs = styledWithTheme('thead')(function (_ref) {
  var theme = _ref.theme;
  return {
    fontSize: px(theme.selectors.fontSize('T200')),
    fontWeight: theme.selectors.fontWeight('regular')
  };
});
var Thead = describe(TheadWithoutDocs).description("Stencil-styled HTML 'thead' element.");
Thead.propTypes = {};
Thead.displayName = 'Thead';
export default Thead;